module.exports = __webpack_public_path__ + "static/media/darkEarnings.ea3d01b3.svg";